module.exports = __webpack_public_path__ + "img/new.24342a77.png";